<script setup lang="ts">
  import BillingWallet from './BillingWallet.vue';
</script>

<template>
  <billing-wallet class="flex h-12 flex-row-reverse items-center gap-1 rounded-lg border border-gray-100 p-1" />
</template>
